import _classCallCheck from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';

var ErrorDetails = function ErrorDetails(_ref) {
  var open = _ref.open,
      error = _ref.error,
      errorInfo = _ref.errorInfo,
      msg = _ref.msg;
  return /*#__PURE__*/React.createElement("div", null, typeof msg === 'string' ? /*#__PURE__*/React.createElement("h2", null, msg) : msg, /*#__PURE__*/React.createElement("details", {
    style: {
      whiteSpace: 'pre-wrap'
    },
    open: open
  }, /*#__PURE__*/React.createElement("summary", null, "Error details"), /*#__PURE__*/React.createElement("p", null, error && error.toString()), /*#__PURE__*/React.createElement("h4", {
    className: "swan-mt-4"
  }, "Stack trace:"), /*#__PURE__*/React.createElement("div", null, errorInfo && errorInfo.componentStack)));
};

ErrorDetails.defaultProps = {
  msg: 'Something went wrong!'
};

var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this;

    _classCallCheck(this, ErrorBoundary);

    _this = _super.call(this, props);
    _this.state = {
      error: null,
      errorInfo: null
    };
    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      this.setState({
        error: error,
        errorInfo: errorInfo
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          fallback = _this$props.fallback,
          forceShowError = _this$props.forceShowError,
          errorDetailMsg = _this$props.errorDetailMsg;

      if (!this.state.error) {
        return children;
      }

      return /*#__PURE__*/React.createElement(React.Fragment, null, fallback, forceShowError || !fallback ? /*#__PURE__*/React.createElement(ErrorDetails, {
        error: this.state.error,
        errorInfo: this.state.errorInfo,
        open: !fallback,
        msg: errorDetailMsg
      }) : null);
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      return {
        error: error
      };
    }
  }]);

  return ErrorBoundary;
}(React.Component);

export { ErrorBoundary };